import { useMemo } from 'react';
import { useUserInterests } from 'integration/hooks/useUserInterests';
import { PREFERENCES_CODE } from 'integration/hooks/useInterest';
import { HOBBIES_CODE } from '@/data/Content/Hobbies';

export const useDpFanUserHasInterests = () => {
	const userInterestsQuery = useUserInterests();

	const hasCustomInterests = useMemo(
		() =>
			userInterestsQuery.userInterests?.filter(
				(item) =>
					item.name.toLocaleLowerCase().trim() !== PREFERENCES_CODE &&
					item.name.toLocaleLowerCase().trim() !== HOBBIES_CODE
			).length > 0,
		[userInterestsQuery.userInterests]
	);

	return {
		isLoadingUserInterests: userInterestsQuery.isLoadingUserInterests,
		isUserLoggedIn: userInterestsQuery.isUserLoggedIn,
		hasCustomInterests,
	};
};
